import React from "react";

import {
  FiCreditCard,
  FiEdit,
  FiEye,
  FiRotateCcw,
  FiXCircle,
} from "react-icons/fi";

import {
  FaSpinner,
} from "react-icons/fa";

import EmployeePagination
  from "../common/EmployeePagination";

import EmployeeStatusBadge
  from "../common/EmployeeStatusBadge";

import {
  formatEmployeeCurrency,
  formatEmployeeDate,
} from "../utils/employee.utils";

import "./EmployeeAdvance.css";


const EmployeeAdvanceTable = ({
  records = [],

  loading = false,

  page = 1,

  limit = 10,

  totalRecords = 0,

  totalPages = 1,

  onPageChange,

  onLimitChange,

  onView,

  onEdit,

  onRecover,

  onCancel,
}) => {

  if (
    loading
  ) {

    return (

      <div className="employee-advance-loading">

        <FaSpinner />

        <span>
          Loading employee advances...
        </span>

      </div>

    );

  }


  return (

    <section className="employee-advance-table-card">

      <div className="employee-advance-table-heading">

        <div>

          <span>
            ADVANCES
          </span>

          <h2>
            Advance Records
          </h2>

          <p>
            Track advances, recovered amount and outstanding balances.
          </p>

        </div>

      </div>


      <div className="employee-advance-table-scroll">

        <table className="employee-advance-table">

          <thead>

            <tr>

              <th>#</th>

              <th>
                Employee
              </th>

              <th>
                Advance Date
              </th>

              <th>
                Advance Amount
              </th>

              <th>
                Recovered
              </th>

              <th>
                Balance
              </th>

              <th>
                Recovery Type
              </th>

              <th>
                Status
              </th>

              <th>
                Actions
              </th>

            </tr>

          </thead>


          <tbody>

            {
              records.length ===
              0
                ?
                (
                  <tr>

                    <td
                      colSpan="9"
                      className="employee-advance-empty"
                    >

                      <FiCreditCard />

                      <strong>
                        No employee advances found
                      </strong>

                      <span>
                        Add an advance to start tracking employee recoveries.
                      </span>

                    </td>

                  </tr>
                )
                :
                records.map(
                  (
                    advance,
                    index
                  ) => {

                    const employee =
                      advance?.employeeId &&
                      typeof advance.employeeId ===
                        "object"
                        ?
                        advance.employeeId
                        :
                        advance?.employee ||
                        {};


                    const advanceAmount =
                      Number(
                        advance?.advanceAmount ??
                        advance?.amount ??
                        0
                      );


                    const recoveredAmount =
                      Number(
                        advance?.recoveredAmount ??
                        advance?.totalRecoveredAmount ??
                        0
                      );


                    const balanceAmount =
                      Number(
                        advance?.balanceAmount ??
                        Math.max(
                          advanceAmount -
                          recoveredAmount,
                          0
                        )
                      );


                    const status =
                      advance?.status ||
                      (
                        balanceAmount <=
                        0
                          ?
                          "RECOVERED"
                          :
                          recoveredAmount >
                          0
                            ?
                            "PARTIALLY_RECOVERED"
                            :
                            "ACTIVE"
                      );


                    const disabled =
                      [
                        "RECOVERED",
                        "CANCELLED",
                      ].includes(
                        String(
                          status
                        ).toUpperCase()
                      );


                    return (

                      <tr
                        key={
                          advance?._id ||
                          index
                        }
                      >

                        <td>
                          {
                            (
                              Number(
                                page
                              ) -
                              1
                            ) *
                            Number(
                              limit
                            ) +
                            index +
                            1
                          }
                        </td>


                        <td>

                          <div className="employee-advance-person">

                            <strong>
                              {
                                employee?.name ||
                                advance?.employeeName ||
                                "-"
                              }
                            </strong>

                            <span>
                              {
                                employee?.employeeCode ||
                                advance?.employeeCode ||
                                "-"
                              }
                            </span>

                          </div>

                        </td>


                        <td>

                          {
                            formatEmployeeDate(
                              advance?.advanceDate ||
                              advance?.date ||
                              advance?.createdAt
                            )
                          }

                        </td>


                        <td>

                          <strong>
                            {
                              formatEmployeeCurrency(
                                advanceAmount
                              )
                            }
                          </strong>

                        </td>


                        <td>

                          <span className="employee-advance-recovered">

                            {
                              formatEmployeeCurrency(
                                recoveredAmount
                              )
                            }

                          </span>

                        </td>


                        <td>

                          <strong
                            className={
                              balanceAmount >
                              0
                                ?
                                "employee-advance-balance pending"
                                :
                                "employee-advance-balance completed"
                            }
                          >

                            {
                              formatEmployeeCurrency(
                                balanceAmount
                              )
                            }

                          </strong>

                        </td>


                        <td>

                          {
                            String(
                              advance?.recoveryType ||
                              "MANUAL"
                            )
                              .replace(
                                /_/g,
                                " "
                              )
                          }

                        </td>


                        <td>

                          <EmployeeStatusBadge
                            status={
                              status
                            }
                          />

                        </td>


                        <td>

                          <div className="employee-advance-actions">

                            <button
                              type="button"
                              onClick={
                                () =>
                                  onView?.(
                                    advance
                                  )
                              }
                              title="View"
                            >

                              <FiEye />

                            </button>


                            <button
                              type="button"
                              onClick={
                                () =>
                                  onEdit?.(
                                    advance
                                  )
                              }
                              disabled={
                                disabled
                              }
                              title="Edit"
                            >

                              <FiEdit />

                            </button>


                            <button
                              type="button"
                              className="employee-advance-recover-action"
                              onClick={
                                () =>
                                  onRecover?.(
                                    advance
                                  )
                              }
                              disabled={
                                disabled
                              }
                              title="Recover"
                            >

                              <FiRotateCcw />

                            </button>


                            <button
                              type="button"
                              className="employee-advance-cancel-action"
                              onClick={
                                () =>
                                  onCancel?.(
                                    advance
                                  )
                              }
                              disabled={
                                disabled
                              }
                              title="Cancel"
                            >

                              <FiXCircle />

                            </button>

                          </div>

                        </td>

                      </tr>

                    );

                  }
                )
            }

          </tbody>

        </table>

      </div>


      {
        totalRecords >
        0
          ?
          (
            <EmployeePagination
              page={
                page
              }
              limit={
                limit
              }
              totalRecords={
                totalRecords
              }
              totalPages={
                totalPages
              }
              onPageChange={
                onPageChange
              }
              onLimitChange={
                onLimitChange
              }
            />
          )
          :
          null
      }

    </section>

  );

};


export default EmployeeAdvanceTable;